import { useEffect, useState } from "react";
import { DataHora } from "./Grid";
import styled from "styled-components";
import api from "../api";

const ExtratoItem = styled.div`
  padding: 10px;
  margin-bottom: 15px;
  border: 1px solid #ccc;
  border-radius: 8px;
  background-color:  ${props => props.movimento === 2 ? '#d4edda' : '#ffe5e5'};
`;

const Linha = styled.div`
  margin-bottom: 4px;
  font-size: 16px;
`;

const LinhaCenter = styled.div`
  margin-bottom: 4px;
  font-size: 16px;
  text-align: center;
`;




/*

async function DadosUsuario(idUsuario) {
  try {
    const res = await api.get("liga/dadosUsuario/"+idUsuario);
    setUsuario(res.data);
  } catch (error) {
    //toast.error(error.message);
  }
};*/


const DescricaoFinanceiro = ({ financeiro, adm }) => {

  const[usuario, setUsuario] = useState(null)  

  const getDados = async () => {
    try {
      const res = await api.get("liga/dadosUsuario/"+financeiro[0].idUsuario);
      setUsuario(res.data);
    } catch (error) {
      //toast.error(error.message);
    }
  
  };

  useEffect(() => {

    getDados();

  }, [financeiro])

    return (
        <>
          <br/><ExtratoItem movimento={(usuario?.valor ?? 0) >= 0 ? 2 : 1} key={1}>
          <LinhaCenter><strong>Saldo Atualizado: </strong>{new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(usuario?.valor ?? 0)}</LinhaCenter>
          </ExtratoItem>
            { financeiro.map((f) => (
                <ExtratoItem key={f.id} movimento={f.movimento}>
                <Linha><strong>Id:</strong> {f.id}</Linha>
                <Linha><strong>Data:</strong> {DataHora(f.data)}</Linha>
                <Linha><strong>Movimento:</strong> {f.movimento} {f.proxyMovimento}</Linha>
                <Linha><strong>Descrição:</strong> {f.descricaoMovimento}</Linha>
                <Linha><strong>Valor:</strong> {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(f.valor)}</Linha>
                </ExtratoItem>
            ))}

            {/* adm && financeiro.map((f) => (
                <ExtratoItem key={f.id}>
                <Linha><strong>Id:</strong> {f.id}</Linha>
                <Linha><strong>Data:</strong> {DataHora(f.data)}</Linha>
                <Linha><strong>Movimento:</strong> {f.movimento} {f.proxyMovimento}</Linha>
                <Linha><strong>Descrição:</strong> {f.descricaoMovimento}</Linha>
                <Linha><strong>Valor:</strong> {new Intl.NumberFormat("pt-BR", { style: "currency", currency: "BRL" }).format(f.valor)}</Linha>
                </ExtratoItem>
            ))*/}
        </>
    )
}

export default DescricaoFinanceiro;